/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useEffect, useState } from "react";
import { TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import VwHbsIslemtanimDTO from "src/models/GenelTanimlar/VwHbsIslemtanimDTO";
import hbsislemtanimService from "src/services/geneltanimlar/hbsislemtanim.service";
import { helper } from "src/utils/helper";
import { AutoCompleteTargetString } from "../Types/autocomplete.target";
import Highlight from "../Genel/Highlight";
import { AutocompleteChangeDetails, AutocompleteChangeReason, AutocompleteInputChangeReason, FilterOptionsState } from "@mui/base";
import { AutocompleteOwnerState, AutocompleteRenderInputParams, AutocompleteRenderOptionState, SxProps, Theme } from "@mui/material";
import CircularProgress from "src/components/CircularProgress";
import { ApiRequest } from "src/models/api.request";

interface IKurumBonusIslemlerAutoCompleteProps {
    sx?: SxProps<Theme>;
    label?: string;
    error?: boolean;
    helperText?: string;
    value?: number;
    onChange?: (e: AutoCompleteTargetString) => void;
    name?: string;
    onSelect?: (islemler: Array<VwHbsIslemtanimDTO>) => void;
    cokluSecimAktif?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
};

const sleep = (delay: number = 0) => {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
};

const KurumBonusIslemlerAutoComplete = (props: IKurumBonusIslemlerAutoCompleteProps): JSX.Element => {
    const [options, setOptions] = useState<Array<VwHbsIslemtanimDTO>>(new Array<VwHbsIslemtanimDTO>());
    const [searchText, setSearchText] = useState<string>("");
    const [inputText, setInputText] = useState<string>(""); // Input değeri için ayrı state
    const [value, setValue] = useState<VwHbsIslemtanimDTO>(null);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [initialLoaded, setInitialLoaded] = useState<boolean>(false);

    useEffect(() => {
        if (!initialLoaded) {
            if (props.value) {
                // Düzenleme modu: value'ye göre kaydı getir
                loadRecordById(props.value);
            } else {
                // Ekleme modu: Default 50 kaydı getir
                loadInitialData();
            }
        }
    }, [props.value]);

    const loadInitialData = async () => {
        setLoading(true);
        try {
            const req: ApiRequest<VwHbsIslemtanimDTO> = {
                filters: {
                    groupOperator: "and",
                    predicates: [
                        {
                            fieldName: 'aktif',
                            operator: '=',
                            value1: 'E'
                        }
                    ]
                },
                sorts: [
                    {
                        fieldName: "id",
                        ascending: true
                    }
                ],
                pageSize: 50,
                pageIndex: 0,
                paging: true,
            };

            const response = await hbsislemtanimService.find(req);
            if (response.data) {
                setOptions(response.data);
                setInitialLoaded(true);
            }
            if (response.errorMessage) {
                setErrorMessage(response.errorMessage);
            }
        } catch (error) {
            setErrorMessage("Veri yüklenirken hata oluştu");
        } finally {
            setLoading(false);
        }
    };

    const loadRecordById = async (id: number) => {
        setLoading(true);
        try {
            const req: ApiRequest<VwHbsIslemtanimDTO> = {
                filters: {
                    groupOperator: "and",
                    predicates: [
                        {
                            fieldName: 'id',
                            operator: '=',
                            value1: id
                        },
                        {
                            fieldName: 'aktif',
                            operator: '=',
                            value1: 'E'
                        }
                    ]
                },
                pageSize: 1,
                pageIndex: 0,
                paging: true,
                sorts: [
                    {
                        fieldName: "id",
                        ascending: true
                    }
                ],
            };

            const response = await hbsislemtanimService.find(req);
            if (response.data && response.data.length > 0) {
                const record = response.data[0];
                setValue(record);
                setOptions([record]); // Sadece bu kaydı options'a koy
                setInitialLoaded(true);

                // onChange event'ini tetikle
                if (props.onChange) {
                    props.onChange({ target: { value: record.id?.toString(), name: props.name } });
                }

                // onSelect event'ini tetikle
                if (props.onSelect) {
                    props.onSelect([record]);
                }
            }
            if (response.errorMessage) {
                setErrorMessage(response.errorMessage);
            }
        } catch (error) {
            setErrorMessage("Kayıt yüklenirken hata oluştu");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let active = true;

        // Düzenleme modundaysa (value varsa) arama yapma
        if (props.value) {
            return;
        }

        if (searchText?.length >= 3) {
            if (!loading) {
                (async () => {
                    await sleep(300);
                    if (active) {
                        setLoading(true);
                        try {
                            const req: ApiRequest<VwHbsIslemtanimDTO> = {
                                filters: {
                                    groupOperator: "and",
                                    predicates: [
                                        {
                                            fieldName: 'aktif',
                                            operator: '=',
                                            value1: 'E'
                                        },
                                        {
                                            groupOperator: "or",
                                            predicates: [
                                                {
                                                    fieldName: 'adi',
                                                    operator: 'like',
                                                    value1: `%${helper.upperCase(searchText)}%`
                                                },
                                                {
                                                    fieldName: 'kodu',
                                                    operator: 'like',
                                                    value1: `%${helper.upperCase(searchText)}%`
                                                },
                                                {
                                                    fieldName: 'analizaciklama',
                                                    operator: 'like',
                                                    value1: `%${helper.upperCase(searchText)}%`
                                                }
                                            ]
                                        }
                                    ]
                                },
                                sorts: [
                                    {
                                        fieldName: "id",
                                        ascending: true
                                    }
                                ],
                                pageSize: 50,
                                pageIndex: 0,
                                paging: true,
                            };

                            const response = await hbsislemtanimService.find(req);
                            if (response.data) {
                                setOptions(response.data);
                                setErrorMessage("");
                            }
                            if (response.errorMessage) {
                                setErrorMessage(response.errorMessage);
                            }
                        } catch (error) {
                            setErrorMessage("Arama yaparken hata oluştu");
                        } finally {
                            setLoading(false);
                        }
                    }
                })();
            }
        } else if (searchText?.length === 0 && initialLoaded && !props.value) {
            loadInitialData();
        }

        return () => {
            active = false;
        };
    }, [searchText, props.value]);

    const filterDataOptions = (data: Array<VwHbsIslemtanimDTO>): readonly VwHbsIslemtanimDTO[] => {
        if (!Array.isArray(data))
            return [];
        return data;
    };

    const isOptionEqualToValue = (option: VwHbsIslemtanimDTO, value: VwHbsIslemtanimDTO): boolean => {
        return option && value && option.id === value.id;
    };

    const filterOptions = (options: VwHbsIslemtanimDTO[], state: FilterOptionsState<unknown>): VwHbsIslemtanimDTO[] => {
        return options;
    };

    const renderInput = (params: AutocompleteRenderInputParams): React.ReactNode => {
        return (
            <TextField
                {...params}
                autoFocus
                required={props.required}
                disabled={loading || props.disabled}
                label={props.label || "İşlem Seçiniz"}
                error={props.error || Boolean(errorMessage)}
                helperText={errorMessage}
                placeholder={props.placeholder}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <>
                            {loading ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                        </>
                    )
                }}
            />
        );
    };

    const onInputChange = (event: React.SyntheticEvent<Element, Event>, value: string, reason: AutocompleteInputChangeReason): void => {
        setInputText(value); // Her durumda input text'i güncelle
        if (reason === "input") {
            setSearchText(value);
        } else if (reason === "reset") {
            // Autocomplete reset olduğunda (seçim yapıldıktan sonra) searchText'i temizle
            setSearchText("");
        }
    };

    const getOptionLabel = (option: VwHbsIslemtanimDTO): string => {
        if (!option.adi)
            return "";
        return `{${option.kodu}} / ${option.adi}`;
    };

    const renderOption = (props, option: VwHbsIslemtanimDTO, state: AutocompleteRenderOptionState, ownerState: AutocompleteOwnerState<VwHbsIslemtanimDTO, boolean, boolean, boolean, "div">): React.ReactNode => {
        if (!option?.id)
            return "";
        return (
            <li {...props} key={option.id}>
                <div style={{ width: '100%' }}>
                    <div>
                        <Highlight fullString={`${option.kodu} - ${option.adi}`} matchString={searchText} />
                    </div>
                    {option.analizaciklama && (
                        <div style={{ fontSize: '0.875rem', color: 'gray', marginTop: '4px' }}>
                            <Highlight fullString={option.analizaciklama} matchString={searchText} />
                        </div>
                    )}
                </div>
            </li>
        );
    };

    const [update, setUpdate] = useState(false);
    useEffect(() => {
        if (update && value) {
            if (props.onSelect) {
                props.onSelect([value]);
            }
            setUpdate(false);
        }
    }, [update, value]);

    const onChangeHandler = (event: React.SyntheticEvent<Element, Event>, value: VwHbsIslemtanimDTO, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<VwHbsIslemtanimDTO>): void => {
        if (reason === "clear") {
            setValue(null);
            if (props.onChange)
                props.onChange({ target: { value: null, name: props.name } });
            return;
        }
        if (reason === "selectOption") {
            if (value) {
                setValue(value);
                if (props.onChange)
                    props.onChange({ target: { value: value.id?.toString(), name: props.name } });
                setUpdate(true);
            }
        }
    };

    return (
        <Autocomplete
            fullWidth
            autoComplete
            includeInputInList
            // disableCloseOnSelect
            sx={props?.sx}
            freeSolo={false}
            multiple={false}
            disabled={props.disabled}
            readOnly={props.readOnly}
            value={value}
            placeholder={props.placeholder}
            filterOptions={filterOptions}
            options={filterDataOptions(options)}
            isOptionEqualToValue={isOptionEqualToValue}
            renderInput={renderInput}
            onInputChange={onInputChange}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            onChange={onChangeHandler}
            loading={loading}
            loadingText="Aranıyor..."
            noOptionsText={props.value ? "Kayıt bulunamadı" : (inputText?.length >= 3 ? "Sonuç bulunamadı" : "Arama yapmak için en az 3 karakter giriniz")}
        />
    );
};

export default KurumBonusIslemlerAutoComplete;
